module.exports = __webpack_public_path__ + "static/media/draft.117a2036.svg";